/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { INurse } from 'app/shared/model/nurse.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IAldreteScore } from 'app/shared/model/aldrete-score.model';
import { IBehaviouralPainScore } from 'app/shared/model/behavioural-pain-score.model';
import { IFlaccScore } from 'app/shared/model/flacc-score.model';
import { INipsScore } from 'app/shared/model/nips-score.model';
import { IWongBakersPainScore } from 'app/shared/model/wong-bakers-pain-score.model';
import { IPostOpRecovery } from 'app/shared/model/post-op-recovery.model';
import { SedationScore } from 'app/shared/model/enumerations/sedation-score.model';
import { IntakeType } from 'app/shared/model/enumerations/intake-type.model';
import { OutputType } from 'app/shared/model/enumerations/output-type.model';
import { PainScale } from 'app/shared/model/enumerations/pain-scale.model';

export interface IPostOPRecoveryRecord {
  id?: string;
  time?: number | null;
  painScore?: string | null;
  sedationScore?: keyof typeof SedationScore | null;
  intakeType?: keyof typeof IntakeType | null;
  intakeAmount?: string | null;
  outputType?: keyof typeof OutputType | null;
  outputAmount?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  sedationScoreValue?: string | null;
  painScale?: keyof typeof PainScale | null;
  surgery?: IPatientProcedure;
  nurse?: INurse;
  vitals?: IVitals | null;
  aldreteScore?: IAldreteScore | null;
  behaviouralPainScore?: IBehaviouralPainScore | null;
  flaccScore?: IFlaccScore | null;
  nipsScore?: INipsScore | null;
  wongBakersPainScore?: IWongBakersPainScore | null;
  postOpRecovery?: IPostOpRecovery;
}

export const defaultValue: Readonly<IPostOPRecoveryRecord> = {
  active: false,
};
